import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

function ErrosUploadDocumentosModal({
  open,
  message,
  errors = [],
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Erros nos documentos</DialogTitle>
      <DialogContent>
        <Alert severity="error" sx={{ mb: 2 }}>
          {message ||
            "Não foi possível salvar a solicitação devido a erros nos documentos."}
        </Alert>
        <List dense>
          {errors.map((item, index) => (
            <ListItem key={`${item.field}-${index}`} disableGutters>
              <ListItemText
                primary={item.field || "Arquivo"}
                secondary={item.message}
                primaryTypographyProps={{ variant: "body2", fontWeight: 600 }}
                secondaryTypographyProps={{ variant: "body2" }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="contained" color="secondary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ErrosUploadDocumentosModal;
